module.exports = __webpack_public_path__ + "img/address-company.2324ef00.svg";